import { useNavigate } from "react-router-dom";
import { useCountdown } from "../../hooks/useCountdown";
import type { Gift } from "../../../types";

// Featured, larger card for a Private Drop that's locked or ready-but-not-
// yet-opened - GiftsScreen.tsx renders this INSTEAD OF the plain GiftCard
// row for exactly that state (once opened, it reverts to the normal
// chronological GiftCard row - no permanent screen-space consumption, per
// the brief). No real media thumbnail ever - purely a locked-envelope/
// ready-gift icon composition, matching the "don't leak a preview" rule
// every other gift surface already follows.
export function PrivateDropCard({ gift, onOpen }: { gift: Gift; onOpen: (gift: Gift) => void }) {
  const navigate = useNavigate();
  const countdown = useCountdown(gift.locked ? gift.unlockAt : null);
  const isReceived = gift.direction === "received";

  function handleTap(): void {
    if (gift.locked) {
      navigate(`/gifts/drop/${gift.id}`);
      return;
    }
    onOpen(gift);
  }

  return (
    <button
      type="button"
      className={`private-drop-card${gift.locked ? " is-locked" : " is-ready"}`}
      onClick={handleTap}
      aria-label={gift.locked ? `Private Drop, unlocks in ${countdown.label}` : "Open Private Drop"}
    >
      <span className="private-drop-card-icon" aria-hidden="true">
        <i className={`bi ${gift.locked ? "bi-lock-fill" : "bi-gift-fill"}`} />
      </span>
      <span className="private-drop-card-label">Private Drop</span>
      {gift.locked ? (
        <>
          <span className="private-drop-card-countdown-label">Unlocks in</span>
          <span className="private-drop-card-countdown">{countdown.label}</span>
        </>
      ) : (
        <span className="private-drop-card-ready-label">Ready to open</span>
      )}
      <span className="private-drop-card-from">{isReceived ? `From ${gift.senderName}` : `To ${gift.recipientName}`}</span>
      {gift.locked && gift.unlockAt && (
        <span className="private-drop-card-unlock-at">
          Unlocks{" "}
          {new Date(gift.unlockAt).toLocaleDateString(undefined, { month: "short", day: "numeric" })} at{" "}
          {new Date(gift.unlockAt).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })}
        </span>
      )}
    </button>
  );
}
